import script from "./CustomerNote.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerNote.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerNote.vue?vue&type=style&index=0&id=163fdf4b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163fdf4b"]])

export default __exports__